/**
 * TanStack Query hooks for `igaming-ftd-event`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingFtdEventQueryKeys,
	type CreateIgamingFtdEventBody,
	type ListIgamingFtdEventResponse,
	type IgamingFtdEventRow,
} from "./api";

export function useIgamingFtdEventList(): UseQueryResult<ListIgamingFtdEventResponse, Error> {
	return useQuery({
		queryKey: igamingFtdEventQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingFtdEventCreate(): UseMutationResult<IgamingFtdEventRow, Error, CreateIgamingFtdEventBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingFtdEventQueryKeys.all });
		},
	});
}

export function useIgamingFtdEventDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingFtdEventQueryKeys.all });
		},
	});
}
